/*
  Turns the native <select> inside Quantity Breaks rows into a dropdown that
  shows the variant image next to each value (colour pickers only).

  The native select stays in the DOM — it is only hidden — so the theme's own
  logic keeps working: picking a value writes to the select and fires a real
  `change` event, exactly like a user interacting with the select.

  Options with no variant image (Size, Length, ...) are left untouched.
*/
(function () {
  var BUILT = 'qbImageSelect';
  var registry = new WeakMap();
  var openInstance = null;

  function variantsOf(root) {
    var el = root.querySelector('script[type="application/json"][data-has-variants]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function imageFor(variants, position, value) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v['option' + position] !== value) continue;
      var img = v.featured_image || v.image;
      var src = img && (img.src || img);
      if (typeof src === 'string' && src) return src;
    }
    return null;
  }

  function sized(src, px) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + px;
  }

  function thumb(src) {
    var img = document.createElement('img');
    img.className = 'qb-image-select__thumb';
    img.src = sized(src, 120);
    img.alt = '';
    img.loading = 'lazy';
    img.width = 22;
    img.height = 22;
    return img;
  }

  function row(entry) {
    return entry.wrap.closest('.quantity-break');
  }

  function closeOpen() {
    if (!openInstance) return;
    openInstance.panel.hidden = true;
    openInstance.wrap.classList.remove('is-open');
    openInstance.trigger.setAttribute('aria-expanded', 'false');
    var parentRow = row(openInstance);
    if (parentRow) parentRow.classList.remove('qb-has-open-dropdown');
    openInstance = null;
  }

  function renderTrigger(entry) {
    var select = entry.select;
    var value = select.value;
    entry.trigger.textContent = '';
    if (entry.images[value]) entry.trigger.appendChild(thumb(entry.images[value]));
    var name = document.createElement('span');
    name.className = 'qb-image-select__name';
    name.textContent = value;
    entry.trigger.appendChild(name);
    var caret = document.createElement('span');
    caret.className = 'qb-image-select__caret';
    caret.setAttribute('aria-hidden', 'true');
    caret.textContent = '▾';
    entry.trigger.appendChild(caret);
  }

  function renderPanel(entry) {
    var select = entry.select;
    entry.panel.textContent = '';

    Array.prototype.forEach.call(select.options, function (option) {
      if (option.classList.contains('non-existent')) return;

      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'qb-image-select__option';
      if (option.classList.contains('unavailable')) {
        item.className += ' qb-image-select__option--unavailable';
      }
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', option.value === select.value ? 'true' : 'false');

      if (entry.images[option.value]) item.appendChild(thumb(entry.images[option.value]));

      var name = document.createElement('span');
      name.className = 'qb-image-select__name';
      name.textContent = option.textContent.trim();
      item.appendChild(name);

      item.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        renderTrigger(entry);
        renderPanel(entry);
        closeOpen();
      });

      entry.panel.appendChild(item);
    });
  }

  function build(select, position, variants) {
    var images = {};
    var withImage = [];
    var distinct = {};
    var distinctCount = 0;

    Array.prototype.forEach.call(select.options, function (option) {
      var src = imageFor(variants, position, option.value);
      if (!src) return;
      images[option.value] = src;
      withImage.push(option.value);
      if (!distinct[src]) {
        distinct[src] = true;
        distinctCount++;
      }
    });

    // Only options whose values map to their OWN image are picture options
    // (colour). Size resolves to whatever image the first matching variant
    // has — the same picture for every size — so it gets the same dropdown
    // without thumbnails, keeping both controls visually identical.
    if (distinctCount < 2 || distinctCount !== withImage.length) images = {};

    select.dataset[BUILT] = '1';

    var container = select.closest('.select') || select.parentElement;
    var wrap = document.createElement('div');
    wrap.className = 'qb-image-select';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'qb-image-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var panel = document.createElement('div');
    panel.className = 'qb-image-select__panel';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;

    wrap.appendChild(trigger);
    wrap.appendChild(panel);

    var entry = { select: select, wrap: wrap, trigger: trigger, panel: panel, images: images, container: container };
    registry.set(select, entry);

    // Capture phase on the whole widget: the theme's handlers on the bundle
    // rows call stopPropagation, so a bubble listener on the button only ever
    // saw part of the clicks. Capture runs first, and the entire control —
    // thumbnail, label, caret, padding — is one hit area.
    wrap.addEventListener(
      'click',
      function (event) {
        // let option clicks reach their own handler
        if (panel.contains(event.target)) return;

        event.preventDefault();
        event.stopPropagation();

        var wasOpen = openInstance === entry;
        closeOpen();
        if (wasOpen) return;
        renderPanel(entry);
        panel.hidden = false;
        wrap.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        var parentRow = row(entry);
        if (parentRow) parentRow.classList.add('qb-has-open-dropdown');
        openInstance = entry;
      },
      true
    );

    select.addEventListener('change', function () {
      renderTrigger(entry);
    });

    container.classList.add('qb-image-select__native');
    container.parentElement.insertBefore(wrap, container.nextSibling);

    renderTrigger(entry);
  }

  function init(root) {
    var variants = variantsOf(root);
    if (!variants.length) return;

    // a re-render can drop the element that is currently open
    if (openInstance && !openInstance.wrap.isConnected) openInstance = null;

    root.querySelectorAll('.quantity-break__selector-item').forEach(function (item) {
      var selects = item.querySelectorAll('.quantity-break__variant-select');
      selects.forEach(function (select, index) {
        var position = index + 1;
        var entry = registry.get(select);
        if (entry) {
          if (!entry.wrap.isConnected) registry.delete(select);
          else {
            renderTrigger(entry);
            return;
          }
        }
        if (select.dataset[BUILT] && registry.get(select)) return;
        build(select, position, variants);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('quantity-breaks').forEach(function (root) {
      init(root);

      if (root.dataset.qbImageSelectObserved) return;
      root.dataset.qbImageSelectObserved = '1';

      var pending = null;
      new MutationObserver(function () {
        // the theme re-renders rows on variant / bundle changes
        clearTimeout(pending);
        pending = setTimeout(function () {
          init(root);
        }, 60);
      }).observe(root, { childList: true, subtree: true });
    });
  }

  // Capture phase: the theme's own handlers on the bundle rows call
  // stopPropagation, so a bubble-phase listener never sees clicks outside the
  // panel and the dropdown could not be dismissed. Clicks inside the open
  // widget are left to the trigger / option handlers.
  document.addEventListener(
    'click',
    function (event) {
      if (!openInstance) return;
      if (openInstance.wrap.contains(event.target)) return;
      closeOpen();
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeOpen();
  });
  document.addEventListener('shopify:section:load', initAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
